import CurrentUserContext from 'providers/CurrentUser';
import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import credentialsService from 'services/credentialsService';
import DashPageWrapper from './components/DashPageWrapper';

import './Dashboard.styles.scss';

const DashboardRouter: React.FC = () => {
  const { isAuthorised } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthorised && !credentialsService.token) {
      navigate('/auth');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dashboard-router">
      <DashPageWrapper>
        <Outlet />
      </DashPageWrapper>
    </div>
  );
};

export default DashboardRouter;
